import type { UserConfig } from '@tunasong/manifest'
import { normalizeParts } from '@tunasong/schemas'
import { useUserConfig } from '@tunasong/ui-lib'

export type PerformanceConfig = NonNullable<UserConfig['performance']>

/**
 * The user's performance preferences, synced through their profile.
 *
 * Writes go through `updatePerformanceConfig`, which merges a patch over the current value in ONE
 * config write: `updateUserConfigByKey` replaces the whole `performance` key, so two writes made from
 * the same render would lose the first.
 */
export const usePerformanceConfig = () => {
  const [stored, updateStored, hasLoaded] = useUserConfig('performance')
  const config: PerformanceConfig = stored ?? {}
  const updatePerformanceConfig = (patch: Partial<PerformanceConfig>) => updateStored({ ...config, ...patch })
  /** Before the profile loads the config reads as empty, which is indistinguishable from "no default parts" */
  return { config, defaultParts: normalizeParts(config.defaultParts), updatePerformanceConfig, hasLoaded }
}
